import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
    VStack,
} from '@chakra-ui/react';

function FinancialObligationConfirmationModal({
    isOpen,
    onClose,
    onConfirm,
    amount,
}: {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    amount: string;
}) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="md">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Financial Responsibility</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <VStack align="start" spacing={4}>
                        <Text>
                            Cancelling this plan will result in a
                            {' '}
                            <strong>
                                payable balance of
                                {' '}
                                {amount}
                            </strong>
                            {' '}
                            for the property owner.
                        </Text>
                        <Text fontSize="sm" color="gray.600">
                            Please note this amount is calculated as of today
                            and may vary slightly depending on the final cancellation date.
                        </Text>
                        <Text fontSize="sm" fontWeight="medium">
                            By proceeding, you acknowledge that the owner is aware
                            and will be responsible for the final balance payable.
                        </Text>
                        <Button
                            variant="link"
                            colorScheme="blue"
                            size="sm"
                            onClick={() => window.open('https://help.detectorinspector.com.au/hc/en-au/articles/4403206684175-What-is-the-Safer-Home-plan-Cancellation-Policy', '_blank')}
                        >
                            View cancellation policy
                        </Button>
                    </VStack>
                </ModalBody>

                <ModalFooter gap={3}>
                    <Button variant="ghost" onClick={onClose}>
                        Back
                    </Button>
                    <Button
                        colorScheme="secondary"
                        onClick={() => {
                            onConfirm();
                            onClose();
                        }}
                    >
                        Proceed
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

export { FinancialObligationConfirmationModal };
